export default {
	methods: {
		showDeleteModal (title, message) {
			return this.$bvModal.msgBoxConfirm(message, {
				title,
				okTitle: this.$t('modal.ok'),
				cancelTitle: this.$t('modal.cancel'),
				headerBgVariant: 'danger',
				headerTextVariant: 'light',
				okVariant: 'danger',
				cancelVariant: 'link'
			});
		}
	}
};
